'use strict';

import React, { Component } from 'react';

import RegisterProspectForm from './registerProspects.jsx';
import { Button } from '@material-ui/core';
import PopUp from '../../../commonModules/interface/PopUp.jsx';

class RegisterProspectFormList extends Component{

    state = {
        user: this.props.user,
        previousButtonStatus: "btn btn-cancel hidden",
        msg: this.props.msg,
        errormsg:"",
        schemaList: ["","",""],
        forms: ["",""],
        id: 0,
    }
    componentWillMount = () => {
        //Get Schema to be trasnform from Prospect to Client
        try {
            fetch('/schema/prospect/getlist?idClient='+this.props.user, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // 'X-Requested-With': 'XMLHttpRequest',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            }).then(
                (res) => res.json()

            ).then(
                (resp)=>{
                    console.log(resp,"---------------------------_>>>>>");
                    this.setState({schemaList: resp.schemaList, forms: [resp.infoProspect, resp.infoProspect]});
                }
            ).catch( (e) => console.log('error get list ',e))           
        } catch (err) {
            console.log("[ERROR], getting prospect List data",err)
        }
    }
    previous = (e) => {
        e.preventDefault();
        let val = this.state.id;
        console.log("[INFO],regiserInstallation,Go Back to previous Validation");
      
        if (val >= 1){
            val = val -1;
        } else {
            val = 0;
        }
        if (val === 0) {
            this.setState({previousButtonStatus: "btn btn-cancel hidden" });
        }
        this.setState({id: val});
    }
    cancel = (e) => {
        e.preventDefault();
        console.log("Cancel Validation");
        this.setState({ errormsg:""});
        this.props.onCancelation();
    }
    onPreSubmit = (form) => {
        let val = this.state.id;
        console.log('[INFO], Submit form ',val);
        console.log('[INFO], Submit form Data :',form.formData);

        
        if (val >= 2){
            this.onSubmit(form);
            return;
        }
        if (val >= 0){
            this.setState({previousButtonStatus: "btn btn-cancel" });
        }
        let new_form = this.state.forms;
        new_form[val]=form.formData;

        this.setState({id: val+1,forms: new_form});
    }
     onSubmit = async(form) => {
        let last_form = this.state.forms;
        let forms = [];

        last_form.push(form.formData);
        
        forms.push({
            'info': last_form[0],
            'schemaID': this.state.schemaList[0]
        });
        forms.push({
            'info': last_form[1],
            'schemaID': this.state.schemaList[1]
        });
        forms.push({
            'info': last_form[2],
            'schemaID': this.state.schemaList[2]
        });

        console.log("[INFO], Data submitted: ", last_form);
        try {
            const response = await fetch('/user/prospect/update/toClient', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // 'X-Requested-With': 'XMLHttpRequest',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
                body: JSON.stringify({
                    forms: forms,
                    boxAssoId: this.props.user,
                })
            });
            const resp = await response.json();
            console.log(resp);
            if (resp.msg != "OK" ){
                this.setState({errormsg: resp.err.toString()});                    
                return;
            }
            this.props.onValidation();
        } catch (err) {
            console.log('[ERROR], ',err);
            this.setState({
                errormsg: 'Error : ' + err.error
            });
        }
    }
    shouldComponentUpdate=  (nextProps, nextState) => {
        // If you want the render method to execute in the next step
        // return true, else return false
        console.log('[DEBUG], registerProspectsList,,shouldComponentUpdate ',nextProps, this.props);
        if (nextProps !== this.props){
            console.log('[DEBUG], registerProspectsList,,shouldComponentUpdate,true,props',nextProps, this.props);
          return true;
        } else if (nextState !== this.state){
            console.log('[DEBUG], registerProspectsList,,shouldComponentUpdate,true,state',nextState, this.state);
          return true;
        } else {
          return false;
        }
    }
    componentWillUnmount= () => {
        try {
            this.serverRequest.abort();
        } catch (e) {
            console.log(e);
        }
    }
    render(){
        console.log("[DEBUG], Prospect List , ",this.state.schemaList[this.state.id]);
        return (
            <PopUp
                close={this.cancel}
                title={this.props.name}
            >
                <RegisterProspectForm
                    schemaID={this.state.schemaList[this.state.id]}
                    onValidation={this.onPreSubmit}
                    initFormData={this.state.forms[this.state.id]}
                />
                <i style={{color: "red"}}><p>{this.state.errormsg}</p></i>
                <div className="text-right">
                    <Button variant="contained" className={this.state.previousButtonStatus} onClick={this.previous}>Précédent</Button>
                    <Button className="btn btn-cancel" onClick={this.cancel}>Annuler</Button>
                </div>
            </PopUp>
        );
    }
};
export default RegisterProspectFormList
